import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';
import { alterClientStores } from 'bernie-alter';
import { ClientFactories, ContextStore, Store } from 'bernie-core';
import { ClientLogger } from 'bernie-client';
import { ContextInput } from 'bernie-context';
import { NOOP_LOGGER } from 'bernie-logger';

import { BexApiSource } from 'sources/bex-api-source';
import { HotelSearchApiSource } from 'sources/hotel-search-api-source';
import { RateCalendarApiSource } from 'sources/rate-calendar-api-source';
import { ShortlistApiSource } from 'sources/shortlist-api-source';

import { CurrentHotelStore } from './current-hotel-store';
import { MultiItemStore } from './multi-item-store';
import { PageLayoutStore } from './page-layout-store';
import { QualtricsStore } from './qualtrics-store';
import { SearchCriteriaStore } from './search-criteria-store';
import { SearchResultsStore } from './search-results-store';
import { ShortlistStore } from './shortlist-store';
import { UIPageStore } from './ui-page-store';
import { VirtualAgentControlStore } from './virtual-agent-control-store';

export const buildBexApiSource = (contextInput: ContextInput): BexApiSource => {
  const headers = { 'Device-User-Agent-ID': contextInput.identity.duaid };

  // eslint-disable-next-line dot-notation
  const withFederation = window['__STATE__'].experiment?.exposures?.LShop_federation_gateway_loom?.bucket === 1;
  if (withFederation) {
    headers['x-loom-federation'] = true;
  }

  return new BexApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.bexapi'), headers);
};

export const stores: ClientFactories = {
  ...alterClientStores,

  advertising: (): Store => new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.advertising')),
  virtualAgentControlStore: (): Store =>
    new VirtualAgentControlStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.virtualagentcontrol')),

  context: (): Store => new ContextStore(null, NOOP_LOGGER),

  currentHotel: ({ bexApiContext, l10n }): Store =>
    new CurrentHotelStore(
      buildBexApiSource(bexApiContext),
      new HotelSearchApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.hotelsearch')),
      new RateCalendarApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.ratecalendarapi')),
      {},
      l10n,
      ClientLogger.getLoggerWithIdentifier('pwa.store.currenthotel')
    ),
  searchCriteria: ({ l10n }): Store => new SearchCriteriaStore({}, l10n, ClientLogger.getLoggerWithIdentifier('pwa.store.searchcriteria')),

  searchResults: ({ bexApiContext }): Store =>
    new SearchResultsStore(buildBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.searchresults')),

  multiItem: ({ bexApiContext, l10n }): Store =>
    new MultiItemStore(buildBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.multiitem'), l10n),
  pageLayout: ({ bexApiContext }): Store =>
    new PageLayoutStore(buildBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.pagelayout')),
  qualtrics: (): Store => new QualtricsStore({}),
  shortlist: (): Store =>
    new ShortlistStore(
      new ShortlistApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.shortlist')),
      {},
      ClientLogger.getLoggerWithIdentifier('pwa.store.shortlist')
    ),
  uiPage: (): Store => new UIPageStore({}),
};
